import { CHANGE_PROMPT_LOG, VIEW_PROMPT_LOG } from 'constants/auth.constants';

import Loader from 'components/Loader';

const routes = [
	{
		key: '/list/lis/prompts',
		path: '/list/lis/prompts',
		layout: 'list',
		sideMenu: true,
		label: 'Prompts',
		permission: CHANGE_PROMPT_LOG,
		container: Loader(() => import('components/LIS/PromptList')),
		containerProps: {},
	},
	{
		key: '/list/lis/reports',
		path: '/list/lis/reports',
		layout: 'list',
		sideMenu: true,
		label: 'Reports',
		permission: VIEW_PROMPT_LOG,
		container: Loader(() => import('components/LIS/Reports')),
		containerProps: {},
	},
];

export default routes;
